var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"policy-regulations"},[_c('associationNotice',{attrs:{"list":_vm.list,"total":_vm.total},on:{"changePage":_vm.changePage,"click":_vm.toDetails}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }